import type { IconProps } from '../types/IconProps.ts';
export const Volume1: IconProps = {
    name: 'Volume1',
    children: [
        `<path d="M2 15.57V8.43a1 1 0 0 1 1-1h4.21a1 1 0 0 0 .62-.21l3.36-2.6a.5.5 0 0 1 .81.4V19.1a.5.5 0 0 1-.76.43l-4.55-2.81a1 1 0 0 0-.53-.15H3a1 1 0 0 1-1-1M17 7c1.17 1.33 2.8 5.2 0 10" />`,
    ]
};